import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CloseIcon from '@material-ui/icons/Close';
import Grid from '@material-ui/core/Grid';
import { useIntl } from 'react-intl';

const useStyles = makeStyles(theme => ({
    container: {
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(1),
    },
    text: {
        color: '#fff',
        marginRight: theme.spacing(2),
        fontWeight: 500
    },
    textLight: {
        color: '#fff',
        marginRight: theme.spacing(2),
        fontWeight: 700
    },
    icon: {
        color: '#fff',
    },
    alertIcon: {
        marginRight: theme.spacing(2)
    },
    title: {
        textDecoration: 'underline',
        fontSize: 18
    }
}));

const Notification = ({ theme }) => {
    const classes = useStyles();
    const { formatMessage } = useIntl();

    return (
        <Grid container className={classes.container}>
            <Box display="flex" alignItems="center" justifyContent="space-between" borderRadius={12} bgcolor={theme ? "#1f3650": "#2592EA"} flexGrow={1}>
                <Box display="flex" alignItems="center" p={2}>
                    <ErrorOutlineIcon className={clsx(classes.icon, classes.alertIcon)}/>
                    <Typography component="h3" className={classes.text}>
                        { formatMessage({id:"app.notification.undefined", defaultMessage:"2 new undefined topics detected"}) }:
                    </Typography>

                    { theme ? (
                        <>
                            <Typography component="h3" className={clsx(classes.text, classes.title)}>
                                { formatMessage({id:"app.notification.edit", defaultMessage:"Edit"}) } Topic #1
                            </Typography>
                            <Typography component="h3" className={clsx(classes.text, classes.title)}>
                                { formatMessage({id:"app.notification.edit", defaultMessage:"Edit"}) } Topic #2
                            </Typography>
                        </>
                    ): (
                        <Typography component="h3" className={clsx(classes.textLight, classes.title)}>
                            { formatMessage({id:"app.notification.manage", defaultMessage:"Manage Topics"}) }
                        </Typography>
                    )}

                </Box>
                <Box display="flex" alignItems="center" borderLeft={1} borderColor={!theme && "#51A7EE"} alignSelf="stretch">
                    <Box px={2} pb={1} pt={1.5}>
                        <CloseIcon className={classes.icon}/>
                    </Box>
                </Box>
            </Box>
        </Grid>
    )
}

export default Notification;
